import {
  IIllustration,
  IPropsSymptomsIllustrations,
  IUmbracoSymptomsListItemProperties,
  IUmbracoSymptomsListMainProperties,
} from './model';

export const symptomsListDefaultData: IPropsSymptomsIllustrations = {
  isTitleFirst: false,
  illustrations: [],
};

const parseSymptomsListItems = (param: IUmbracoSymptomsListItemProperties[]): IIllustration[] => {
  return param.map((item: IUmbracoSymptomsListItemProperties) => {
    const link = item.properties.symptomDataLink?.[0];

    return {
      title: item.properties.symptomTitle || link?.name,
      titleRTE: item.properties.symptomTitleRTE,
      path: link?.url,
      image: item.properties.symptomDataImage,
      imageAlt: item.properties.symptomDataImageAlt,
      description: item.properties.symptomDescription,
      isTitleFirst: item.properties.isTitleFirst,
    };
  });
};

export const parseSymptomsList = (
  param: IUmbracoSymptomsListMainProperties
): IPropsSymptomsIllustrations => {
  const headingGroupProps =
    param.symptomsHeadingGroup?.length && param.symptomsHeadingGroup[0].properties;
  const result: IPropsSymptomsIllustrations = {
    isTitleFirst: param.isTitleFirst ? param.isTitleFirst : symptomsListDefaultData.isTitleFirst,
    illustrations: param.symptomsListItems
      ? parseSymptomsListItems(param.symptomsListItems)
      : symptomsListDefaultData.illustrations,
    headingGroup: headingGroupProps
      ? {
          showDescriptionOnMobile: headingGroupProps.showDescriptionOnMobile,
          symptomsDescription: headingGroupProps.symptomsDescription,
          symptomsHeadingLg: headingGroupProps.symptomsHeadingLg,
          symptomsHeadingMd: headingGroupProps.symptomsHeadingMd,
        }
      : undefined,
    symptomsAnchor: param.symptomsAnchor,
    description: param?.description,
    symptomsTheme: param?.symptomsTheme,
    symptomsBottomText: param?.symptomsBottomText,
  };

  return result;
};
